import React, { ReactNode } from 'react';

import classNames from 'classnames';

import styles from './Button.module.scss';

type ButtonVariant =
  | 'default'
  | 'primary'
  | 'secondary'
  | 'icon'
  | 'cta'
  | 'payment-card'
  | 'btn-disabled'
  | 'red'
  | 'link';

type ButtonProps = {
  id?: string;
  // eslint-disable-next-line no-unused-vars
  onClick?: (...args: any[]) => void;
  children: ReactNode | string;
  variant?: ButtonVariant;
  classWrapper?: string;
  className?: string;
  disabled?: boolean;
  type?: 'button' | 'reset' | 'submit';
  tabIndex?: number;
  ariaLabel?: string;
};

const Button = ({
  id,
  onClick,
  children,
  variant = 'default',
  classWrapper = '',
  className,
  disabled = false,
  type = 'button',
  tabIndex = 0,
  ariaLabel,
}: ButtonProps) => (
  <button
    id={id || 'button'}
    // eslint-disable-next-line react/button-has-type
    type={type || 'button'}
    className={classNames(styles.default, className, {
      [styles[`btn-${variant}`]]: variant !== 'default',
      [styles[classWrapper]]: !!classWrapper,
      [styles.disabled]: !!disabled,
    })}
    onClick={onClick}
    disabled={disabled}
    tabIndex={tabIndex}
    aria-label={ariaLabel}
  >
    {children}
  </button>
);

export default Button;
